"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _kyruusUiTheme = _interopRequireDefault(require("./kyruus-ui-theme"));
var _utils = require("./utils");
let combineThemes = theme => ({
  ..._kyruusUiTheme.default,
  ...theme
});
if (!(0, _utils.isServerSide)()) {
  // memo-ization is only safe client side. If used in server-side-rendering it will cause a memory leak
  combineThemes = (0, _memoize2.default)(combineThemes);
}

/**
 * Supplies a `theme` prop to the component.
 * It will be the inherited theme object or the
 * default theme object.
 * @param Component - The component to modify.
 * @returns {React.Component}
 */
const withTheme = Component => {
  const ComponentWithTheme = (0, _react2.withTheme)(Component);
  const wrapped = props => /*#__PURE__*/_react.default.createElement(_react2.ThemeProvider, {
    theme: combineThemes
  }, /*#__PURE__*/_react.default.createElement(ComponentWithTheme, props));
  let componentName = Component.displayName || Component.name || 'Component';
  wrapped.displayName = `withTheme(${componentName})`;
  return wrapped;
};
var _default = exports.default = withTheme;